import { render, staticRenderFns } from "./ShipmentSlip54.vue?vue&type=template&id=23d55419&scoped=true&"
import script from "./ShipmentSlip54.vue?vue&type=script&lang=js&"
export * from "./ShipmentSlip54.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentSlip54.vue?vue&type=style&index=0&id=23d55419&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d55419",
  null
  
)

export default component.exports